export const user = {
    id: null,
    email: null,
    name: null,
    addedEventCount: 0,
};